
export const ButtonStyles = (props) => {
  let background = props.disabled || props.hovered ? '#d0d0d0' : '#F5F5F5';
  let styles = {
    width: '3.63em',
    paddingTop: '.5em',
    paddingBottom: '.2em',
    color: "#292b2c",
    background,
    borderColor: "#d0d0d0",
    marginRight: '.75em'
  };

  if(props.small) {
    styles = {...styles, width: '2.85em', paddingTop:'.3em', paddingBottom: '.16em'};
  }
  return styles;
};

export const IconStyles = {
  fontSize: '1.25em',
  height: '1em'
};
